import { useAuth } from "@clerk/clerk-react";
import { Grid } from "@mui/material";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect, useState } from "react";
import { VAStatus } from "schemas/dashboard";

import { fetcherAuth } from "utils/api";

import { OrganizationBulkSendSettingsVersion } from "../DiscoverFilter/AutomationVA/UpcomingPitchScheduleDialog/schema";
import VAAnnouncement from "./VAAnnouncement";
import VAProgressBar from "./VAProgressBar";
import DiscoverVideo from "./Video";

const DiscoverBanner = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { setErrorAlert } = useContext(AlertContext);
  const [closeVa, setCloseVa] = useState(false);
  const { getToken } = useAuth();

  const [hideBar, setHideBar] = useState(true);
  const fetchSettings = async () => {
    if (!currentOrg?.isVaUser) {
      return;
    }
    try {
      const res = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/bulk-send-settings`,
        "GET",
      );
      if (
        res.bulkSendSetting &&
        res.bulkSendSetting.version !== OrganizationBulkSendSettingsVersion.v3
      ) {
        setHideBar(false);
      }
    } catch (error) {
      setErrorAlert(error);
    }
  };

  const notQualifiedForVa =
    currentOrg &&
    [VAStatus.disqualified, VAStatus.not_interested].includes(
      currentOrg?.vaStatus,
    );
  const displayVAAnnouncement = !currentOrg?.isVaUser && !notQualifiedForVa;

  useEffect(() => {
    if (currentOrg?.id) {
      fetchSettings();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return notQualifiedForVa ? (
    <Grid item xs={12}>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <DiscoverVideo />
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Grid container justifyContent="center">
        <Grid item xs>
          {currentOrg?.isVaUser && !hideBar && <VAProgressBar />}
          {displayVAAnnouncement && (
            <VAAnnouncement close={closeVa} setClose={setCloseVa} />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DiscoverBanner;
